import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ProtectedRoute from '../components/ProtectedRoute';
import Login from '../pages/auth/Login';
import ForgotPassword from '../pages/auth/ForgotPassword';
import Dashboard from '../pages/Dashboard';
import Outlets from '../pages/Outlets';
import Riders from '../pages/Riders';
import Orders from '../pages/Orders';
import Customers from '../pages/Customers';
import RiderPayouts from '../pages/RiderPayouts';
import RestaurantPayouts from '../pages/RestaurantPayouts';
import DineInDeposits from '../pages/DineInDeposits';
import LiveEarnings from '../pages/LiveEarnings';
import CreateOutlet from '../pages/CreateOutlet';
import EditOutlet from '../pages/EditOutlet';
import OutletDetails from '../pages/OutletDetails';

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />

      <Route
        path="/outlets"
        element={
          <ProtectedRoute>
            <Outlets />
          </ProtectedRoute>
        }
      />
      <Route
        path="/outlets/create"
        element={
          <ProtectedRoute>
            <CreateOutlet />
          </ProtectedRoute>
        }
      />
      <Route
        path="/outlets/:id/edit"
        element={
          <ProtectedRoute>
            <EditOutlet />
          </ProtectedRoute>
        }
      />
      <Route
        path="/outlets/:id"
        element={
          <ProtectedRoute>
            <OutletDetails />
          </ProtectedRoute>
        }
      />

      <Route
        path="/riders"
        element={
          <ProtectedRoute>
            <Riders />
          </ProtectedRoute>
        }
      />

      <Route
        path="/orders"
        element={
          <ProtectedRoute>
            <Orders />
          </ProtectedRoute>
        }
      />

      <Route
        path="/customers"
        element={
          <ProtectedRoute>
            <Customers />
          </ProtectedRoute>
        }
      />

      <Route
        path="/rider-payouts"
        element={
          <ProtectedRoute>
            <RiderPayouts />
          </ProtectedRoute>
        }
      />

      <Route
        path="/restaurant-payouts"
        element={
          <ProtectedRoute>
            <RestaurantPayouts />
          </ProtectedRoute>
        }
      />

      <Route
        path="/dine-in-deposits"
        element={
          <ProtectedRoute>
            <DineInDeposits />
          </ProtectedRoute>
        }
      />

      <Route
        path="/live-earnings"
        element={
          <ProtectedRoute>
            <LiveEarnings />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}
